import React, { useCallback } from "react"
import { useDispatch } from "react-redux"
import { chartPropatyObj } from "redux/ducks/Chart"
import { BaseSelect } from "components/atoms/input/select"
import _ from "lodash"

interface props {
  list: Array<chartPropatyObj>
  onChange: Function
  defaltValueId?: number
  disabled?: Function
}

const ChartBaseSelector = React.memo((props: props) => {
  const { list, onChange, defaltValueId, disabled } = props

  const changeFunction = useCallback((id: string) => {
    onChange(parseInt(id))
  }, [])

  const createData = () => {
    let dataSource: Array<{
      id: number | string
      name: string
      disabled?: boolean
    }> = []
    _.forEach(list, items => {
      let param = {
        id: items.id,
        name: items.displayTitle,
      }
      if (disabled) _.merge(param, { disabled: disabled(items.id) })
      dataSource.push(param)
    })
    return dataSource
  }

  return (
    <>
      <BaseSelect
        option={createData()}
        defaltValueId={defaltValueId}
        onChange={changeFunction}
      />
    </>
  )
})

export default ChartBaseSelector
